import createReducer from 'utils/create-reducer';
import { createLoader } from 'utils/create-loader';

const getServiceFeeLoader = createLoader('SERVICE_FEE', 'serviceFee');
const initialState = {};
export const reducer = createReducer(initialState, {
  ...getServiceFeeLoader.reducers,
});

export const getServiceFee = () => getServiceFeeLoader.get('/configs/fee');
